import React from 'react';

const AppFormSelect = ({
  label,
  error,
  hint,
  options,
  optionLabel,
  optionValue,
  containerClassName = 'form-control w-full space-y-1 mb-4',
  selectClassName = '',
  placeholder,
  className,
  ...rest
}) => {
  return (
    <div className={containerClassName}>
      {label && (
        <label className="label py-1">
          <span className="label-text text-xs font-bold text-slate-700">{label}</span>
        </label>
      )}
      <select
        className={`select select-bordered w-full rounded-xl bg-white border-slate-300 focus:border-primary focus:ring-2 focus:ring-primary/20 text-sm ${selectClassName} ${className || ''} ${error ? 'select-error' : ''}`}
        {...rest}
      >
        {placeholder && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {options?.map((option, index) => {
          // Handle object options vs primitive options
          const isObject = typeof option === 'object' && option !== null;
          
          let displayLabel = option;
          let val = option;
          
          if (isObject) {
             displayLabel = optionLabel ? option[optionLabel] : option.label || option.name;
             val = optionValue ? option[optionValue] : option.value || option.code || option.id;
             
             // If optionValue is not specified and value/code/id are missing, we might want to JSON.stringify
             // But usually for simple selects we just pass the object, wait, <select> values MUST be strings!
             // So if we need to pass back the full object to onChange, we have to handle it differently, 
             // but standard HTML select only emits string values.
             
             // Let's assume standard behavior where value is a primitive.
             if (val === undefined) val = JSON.stringify(option);
          }
          
          return (
            <option key={val} value={isObject ? val : option}>
              {displayLabel}
            </option>
          );
        })}
      </select>
      {hint && !error && (
        <label className="label py-1">
          <span className="label-text-alt text-slate-500">{hint}</span>
        </label>
      )}
      {error && <p className="text-error text-xs mt-1">{error}</p>}
    </div>
  );
};

export default AppFormSelect;
